import React, { Fragment } from "react";

const ContactThree = () => {
  return (
    <Fragment>
      <div className="row">
        <div className="col-md-4">
          <div className="address-block-two text-center mb-40 sm-mb-20">
            <div className="icon d-flex align-items-center justify-content-center m-auto">
              <img src="images/icon/icon_17.svg" alt="" />
            </div>
            <h5 className="title">Our Address</h5>
            <p>
              {" "}
              HQ NoteG Technologies C-922, Tower C, iThum Business Park Sector-
              62, Electronic City, Noida, Uttar Pradesh 201309
            </p>
          </div>
          {/* /.address-block-two */}
        </div>
        <div className="col-md-4">
          <div className="address-block-two text-center mb-40 sm-mb-20">
            <div className="icon d-flex align-items-center justify-content-center m-auto">
              <img src="images/icon/icon_18.svg" alt="" />
            </div>
            <h5 className="title">Contact Info</h5>
            <p>
              Open a chat or give us call at
              <br />
              <a href="tel:+91-9663497150" className="call">
                +91-9663497150
              </a>
            </p>
          </div>
          {/* /.address-block-two */}
        </div>
        <div className="col-md-4">
          <div className="address-block-two text-center mb-40 sm-mb-20">
            <div className="icon d-flex align-items-center justify-content-center m-auto">
              <img src="images/icon/icon_19.svg" alt="" />
            </div>
            <h5 className="title">Live Support</h5>
            <p>
              live chat service
              <br />
              <a href="#" className="webaddress">
                business@notegtechnologies.com
              </a>
            </p>
          </div>
          {/* /.address-block-two */}
        </div>
      </div>
    </Fragment>
  );
};

export default ContactThree;
